import React, { Component } from 'react';
import './AuthLayout.scss';

// import Logo from '../../assets/images/chai-logo-auth.svg';

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authlayout-main">
      <div className="authlayout-content">
        <div className="authlayout-img-block">
          <div style={{ fontSize: '28px', color: '#000000', fontWeight: 'bold', marginTop: '40px' }}>Bayer LMR</div>
        </div>

        <div className="authlayout-form-block">
          <div className="authlayout-form-inner">
            {children}
          </div>
        </div>
      </div>
      <div className="authlayout-banner-container">
        &nbsp;
      </div>
    </div>
  );
};

export default AuthLayout;
